import { bl_fi_internal_receipt_voucher_import_file_helper_RowClass } from "../../dbschema/bl_fi_internal_receipt_voucher_import_file_helper.model";
import { BaseContainerModel } from "../base-container.model";

export class ReceiptVoucherImportFileHelperContainerModel extends BaseContainerModel {
    bl_fi_internal_receipt_voucher_import_file_helper: bl_fi_internal_receipt_voucher_import_file_helper_RowClass = new bl_fi_internal_receipt_voucher_import_file_helper_RowClass();
}